import { useTranslation } from 'react-i18next';
import { type EndpointListSpecsFragment } from '../../../../../api/fragments/EndpointListSpecs';
import { type MenuItemSpecsFragment } from '../../../../../api/fragments/MenuItemSpecs';
import SelectField from '../../../../../components/fields/SelectField';
import TranslatedInputField from '../../../../../components/fields/TranslatedInputField';
import useSystemOptions from '../../../../../utilities/useSystemOptions';

type RouterMenuItemEndpointProps = {
    menuItems: MenuItemSpecsFragment[];
    name: string;
    endpoints: EndpointListSpecsFragment[];
};

const RouterMenuItemEndpoint = ({ menuItems, name, endpoints }: RouterMenuItemEndpointProps) => {
    const { t } = useTranslation('routerDetails');

    const { antdIconOptions } = useSystemOptions();

    return (
        <>
            <TranslatedInputField
                {...t('routerDetails:menuItems.fields.label', { returnObjects: true })}
                name={`${name}.label`}
                required
            />

            <SelectField
                {...t('routerDetails:menuItems.fields.icon', { returnObjects: true })}
                name={`${name}.icon`}
                options={antdIconOptions}
                showSearch
            />

            <SelectField
                {...t('routerDetails:menuItems.fields.endpointId', { returnObjects: true })}
                name={`${name}.endpointId`}
                options={getAvailableMenuItemList(menuItems, endpoints)}
                required
                showSearch
            />
        </>
    );
};

const getAvailableMenuItemList = (menuItems: MenuItemSpecsFragment[], endpoints: EndpointListSpecsFragment[]) => {
    const availableList = endpoints.filter(
        endpoint => !menuItems.find(item => item.__typename === 'MenuEndpointItem' && item.endpointId === endpoint.id)
    );

    return availableList.map(item => ({
        label: item.pathname,
        value: item.id,
    }));
};

export default RouterMenuItemEndpoint;
